import { createContext, use } from 'react';

interface GuardedFormContextValue {
  guardAction: (action: () => void) => void;
}

export const GuardedFormContext = createContext<GuardedFormContextValue>({
  guardAction: (action: () => void) => action(),
});

export const useGuardedForm = (): GuardedFormContextValue => {
  return use(GuardedFormContext);
};
